import React, { Component } from 'react'
import Styled from 'styled-components'
import { connect } from 'react-redux'

import {
  publishProject
} from 'actions/project'

import {
  savePageChanges
} from 'actions/editor'

import {
  saveThemeChanges
} from 'actions/theme'

import { withRouter } from 'router/index'

import Link from 'components/Link'
import Navigation from 'components/Navigation'
import Button from 'components/Button'
import NavigationBack from 'components/NavigationBack'
import NavigationModes from 'components/NavigationModes'
import NavigationMode from 'components/NavigationMode'

const NavigationExtended = Styled(Navigation)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const Group = Styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-width: 0;
  width: calc(100% / 3);
  height: 100%;
  padding: 0 0.5rem;

  &:first-child {
    justify-content: flex-start;
  }

  &:last-child {
    justify-content: flex-end;
  }

  & > * {
    margin: 0 0.5rem;
  }
`

class ProjectNavigation extends Component {
  state = { // eslint-disable-line
    mode: 'editor'
  }

  static getDerivedStateFromProps(props, state) {
    const mode = props.location.pathname.split('/').pop()

    if (mode === state.mode) {
      return null
    }

    return {
      mode
    }
  }

  handlePublish = () => {
    if (this.props.isSavingOrPublishing) return null

    return this.props.publishProject(this.state.mode)
  }

  handleSave = () => {
    if (this.props.isSavingOrPublishing) return null

    switch (this.state.mode) {
      case 'editor':
        return this.props.savePageChanges()
      case 'theme':
        return this.props.saveThemeChanges()
      default:
        return null
    }
  }

  render() {
    return (
      <NavigationExtended>
        <Group>
          {this.state.mode !== 'preview' &&
            <NavigationBack to="/projects">
              Projects
            </NavigationBack>
          }

          {this.state.mode === 'preview' &&
            <NavigationBack to={`/projects/${this.props.match.params.projectId}/editor`}>
              Editor
            </NavigationBack>
          }
        </Group>

        <Group>
          {this.state.mode !== 'preview' &&
            <NavigationModes>
              <NavigationMode
                to={`/projects/${this.props.match.params.projectId}/editor`}
                liga="edit"
                label="Editor"
              />

              <NavigationMode
                to={`/projects/${this.props.match.params.projectId}/theme`}
                liga="palette"
                label="Theme"
              />

              <NavigationMode
                to={`/projects/${this.props.match.params.projectId}/settings`}
                liga="settings"
                label="Settings"
              />
            </NavigationModes>
          }
        </Group>

        <Group>
          {this.state.mode !== 'preview' &&
            <React.Fragment>
              <Button
                outline
                compact
                disabledSilently={this.props.isSavingOrPublishing}
                loading={this.props.isSaving}
                success={this.props.isSavingSuccessful}
                onClick={this.handleSave}
              >
                Save
              </Button>

              <Link to={`/projects/${this.props.match.params.projectId}/preview`}>
                <Button outline compact>
                  Preview
                </Button>
              </Link>
            </React.Fragment>
          }

          <Button
            compact
            disabledSilently={this.props.isSavingOrPublishing}
            loading={this.props.isPublishing}
            success={this.props.isPublishingSuccessful}
            onClick={this.handlePublish}
          >
            Publish
          </Button>
        </Group>
      </NavigationExtended>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    publishProject: mode => dispatch(publishProject(mode)),
    savePageChanges: () => dispatch(savePageChanges()),
    saveThemeChanges: () => dispatch(saveThemeChanges())    
  }
}

const mapStateToProps = (state) => {
  return {
    isPublishing: state.project.isPublishing,
    isPublishingSuccessful: state.project.isPublishingSuccessful,

    isSaving: state.project.isSaving,
    isSavingSuccessful: state.project.isSavingSuccessful,

    isSavingOrPublishing: (
      state.project.isPublishing || state.project.isPublishingSuccessful ||
      state.project.isSaving || state.project.isSavingSuccessful
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectNavigation))




// WEBPACK FOOTER //
// ./src/components/ProjectNavigation/index.js